import React from 'react'
import ReactPlayer from 'react-player'
import Play from '../images/icons/play.svg'
import Pause from '../images/icons/pause.svg'
import InfoIVideo from '../images/icons/info-i-video.svg'
import classNames from 'classnames'
import Duration from '../components/vendor/cookpete/react-player/duration'
import { isMobileOnly } from 'react-device-detect'
import { throttled } from '../lib/helpers'

class SliderVideo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isReady: false,
      isPlaying: false,
      played: 0,
      loaded: 0,
      duration: 0,
      isInfoTextVisible: false,
      isMouseMoving: false,
    }
    this.onMouseEnterControls = this.onMouseEnterControls.bind(this)
    this.onMouseLeaveControls = this.onMouseLeaveControls.bind(this)
    this.onToggleOverlayClick = this.onToggleOverlayClick.bind(this)
    this.setMouseMove = this.setMouseMove.bind(this)
  }

  onMouseEnterControls() {
    this.setState({
      isMouseOverControls: true,
    })
    document.body.classList.add('is-mouse-over-video-controls')
  }

  onMouseLeaveControls() {
    this.setState({
      isMouseOverControls: false,
    })
    document.body.classList.remove('is-mouse-over-video-controls')
  }

  onToggleOverlayClick() {
    if (!this.state.isMouseOverControls) {
      this.onPause()
    } else {
      this.onPlay()
    }
  }

  onPlay = () => {
    this.setState({
      isPlaying: true,
    })
    this.props.onVideoPlay()
  }

  onPause = () => {
    this.setState({
      isPlaying: false,
    })
  }

  togglePlay = () => {
    this.setState({
      isPlaying: !this.state.isPlaying,
    })
  }

  handleSeekMouseDown = e => {
    this.setState({ seeking: true })
  }

  handleSeekChange = e => {
    this.setState({ played: parseFloat(e.target.value) })
  }

  setMouseMove(e) {
    e.preventDefault()
    this.setState({ isMouseMoving: true })
    // throttled(

    // )
    let timeout
    ;(() => {
      clearTimeout(timeout)
      timeout = setTimeout(() => this.setState({ isMouseMoving: false }), 3000)
    })()
  }

  handleSeekMouseUp = e => {
    this.setState({ seeking: false })
    this.player.seekTo(parseFloat(e.target.value))
  }

  handleDuration = duration => {
    this.setState({ duration })
  }

  handleProgress = state => {
    if (!this.state.seeking) {
      this.setState(state)
    }
  }

  initOverlayToggleAutoplay() {
    const index = this.props.index
    if (document.body.classList.contains(`slide-${index}-video-init`)) {
      this.onPlay()
      document.body.classList.remove(`slide-${index}-video-init`)
    }
  }

  onReady = () => {
    this.setState({
      isReady: true,
    })
    this.initOverlayToggleAutoplay()
  }

  // isSlideIn = () => {
  //   const { slideIndex, index } = this.props
  //   if (slideIndex !== index) {
  //     if (this.state.isPlaying) {
  //       this.setState({
  //         isPlaying: false,
  //       })
  //     }
  //   }
  // }

  ref = player => {
    this.player = player
  }

  render() {
    const { url } = this.props
    const { isReady, isPlaying, played, duration, isInfoTextVisible, isMouseMoving } = this.state
    const classes = classNames({
      'is-paused': !isPlaying,
      'is-playing': isPlaying,
      'is-mouse-moving': isMouseMoving,
      'is-info-text-visible': isInfoTextVisible,
      'is-video-ready': isReady,
    })
    // this.isSlideIn()
    return (
      <div className={`slider-video-container ${classes}`}>
        {/* player */}
        <ReactPlayer
          ref={this.ref}
          url={url}
          width="100%"
          height="100%"
          playing={this.state.isPlaying}
          onPause={this.onPause}
          onProgress={this.handleProgress}
          onDuration={this.handleDuration}
          onReady={this.onReady}
          progressInterval={100}
          playsinline={!isMobileOnly}
        />
        {/* video controls */}
        <div
          className="slider-video__controls"
          onMouseEnter={this.onMouseEnterControls}
          onMouseLeave={this.onMouseLeaveControls}
        >
          <div className="slider-video__controls-inner">
            <div className="slider-video__controls-item slider-video__controls-item--play-toggle">
              <button
                className="btn icon-btn"
                onClick={this.togglePlay}
                aria-label="Toggle video playing"
              >
                <div className="slider-video__play-toggle-icon slider-video__play-toggle-icon--play">
                  <Play />
                </div>
                <div className="slider-video__play-toggle-icon slider-video__play-toggle-icon--pause">
                  <Pause />
                </div>
              </button>
            </div>
            <input
              className="slider-video__controls-item slider-video__controls-item--scrubber"
              type="range"
              min={0}
              max={0.999999}
              step="any"
              value={played}
              onMouseDown={this.handleSeekMouseDown}
              onChange={this.handleSeekChange}
              onMouseUp={this.handleSeekMouseUp}
              style={{ cursor: `pointer` }}
            />
            <div className="slider-video__controls-item slider-video__controls-item--time-info">
              <Duration seconds={duration * played} />
              /
              <Duration seconds={duration} />
            </div>
            <div className="slider-video__controls-item slider-video__controls-item--info-toggle">
              <button onClick={this.toggleInfoText} aria-label="Toggle video info">
                <InfoIVideo />
              </button>
            </div>
          </div>
        </div>
        {/* play toggle overlay */}
        <div
          className="slider-video__play-toggle-overlay"
          onClick={this.onToggleOverlayClick}
          onMouseMove={e => this.setMouseMove(e)}
        >
          <button
            className="slider-video__play-toggle"
            onMouseEnter={this.onMouseEnterControls}
            onMouseLeave={this.onMouseLeaveControls}
            aria-label="Toggle video playing"
          >
            <div className="slider-video__play-toggle-icon slider-video__play-toggle-icon--play">
              <Play />
            </div>
          </button>
        </div>
      </div>
    )
  }
  componentDidUpdate() {
    const { isPlaying, isMouseMoving } = this.state
    if (isPlaying && !isMouseMoving) {
      throttled(800, document.body.classList.add('fade-tooltip'))
    } else {
      throttled(800, document.body.classList.remove('fade-tooltip'))
    }
  }
}

export default SliderVideo
